/* eslint-disable react-hooks/exhaustive-deps */
import { createContext, useEffect, useState } from "react";
import useAxiosPrivate from "../hooks/useAxiosPrivate";

export const AuthContext = createContext({
  currentUser: null,
  setCurrentUser: () => {},
  accessToken: null,
  refreshToken: null,
  csrftoken: null,
  setAccessToken: () => {},
  setRefreshToken: () => {},
  setCSRFToken: () => {},
});

export function AuthContextProvider({ children }) {
  const [currentUser, setCurrentUser] = useState({});
  const [accessToken, setAccessToken] = useState();
  const [refreshToken, setRefreshToken] = useState();
  const [csrftoken, setCSRFToken] = useState();
  const axiosPrivateInstance = useAxiosPrivate();
  const getCurrentUser = async () => {
    try {
      const { data } = await axiosPrivateInstance.get("users/me");
      setCurrentUser(data);
    } catch (error) {
      setCurrentUser(null);
    }
  };
  useEffect(() => {
    if (accessToken) {
      getCurrentUser();
    }
  }, [accessToken]);

  return (
    <AuthContext.Provider
      value={{
        currentUser,
        setCurrentUser,
        accessToken,
        setAccessToken,
        refreshToken,
        setRefreshToken,
        csrftoken,
        setCSRFToken,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export default AuthContext;
